import React, { PureComponent, Fragment } from 'react';
import ReactGA from 'react-ga';
import { Modal, Button } from 'components';
import { logger, checkValidity, arrayToObject } from 'helpers';
import { coreInstance as axios, api } from 'settings';
import createFilterString from '../Configs/createFilterString';
import { Back, Close } from 'components/Icons';
import initialState from './initialState';
import FirstStep from './FirstStep';
import SecondStep from './SecondStep';

import s from './style.module.scss';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';

class CreateModal extends PureComponent {
	constructor(props) {
		super(props);
		this.state = initialState(props);
		this.cache = {
			cities: {},
			concentrators: {},
		};

		this.selectedTimezones = [];
	}

	inputChangedHandler = (event, name) => {
		event.persist && event.persist();

		this.setState((prevState) => {
			const state = { ...prevState.controls };
			const control = state[name];
			let formIsValid = true;

			if (name === 'type') {
				control.checked = { [event.id]: event };
				control.valid = !!Object.keys(control.checked).length;
				control.touched = true;
				var controlTitle = state['title'];
				controlTitle.value = '';
				controlTitle.valid = false;
				var controlDescription = state['description'];
				controlDescription.value = '';

				for (let control in state) {
					formIsValid = state[control].valid && formIsValid;
				}
			} else if (name === 'url_to_open') {
				const target = event.target;
				const value = target.value;
				const regEx =
					/^(https?:\/\/)?([\w.-]+)\.([a-z]{2,6})(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;

				control.touched = true;
				control.value = value;
				control.valid = value.match(regEx) || !value.length;

				for (let control in state) {
					formIsValid = state[control].valid && formIsValid;
				}
			} else {
				const target = event.target;
				const value = target.value;

				if (value.length <= control.validation.maxLength) {
					control.value = value;
					control.valid = checkValidity(value, control.validation);
				}

				for (let control in state) {
					formIsValid = state[control].valid && formIsValid;
				}
			}

			return { controls: state, formIsValid: formIsValid };
		});
	};

	inputFocusOutHandler = (event, name) => {
		this.setState((prevState) => {
			const state = { ...prevState.controls };
			const control = state[name];

			control.touched = true;
			if (name === 'title') {
				if (control.value !== '') {
					control.touched = false;
				}
			}
			return { controls: state };
		});
	};

	checkboxChangedHandler = (event, el, type, timezonesValue) => {
		clearTimeout(this.timer);

		this.setState((prevState) => {
			const state = { ...prevState.controlsGroups };
			let controls = state[type];

			if (type === 'pinCodesByProvider') {
				if (controls[el.provider_id]) {
					if (controls[el.provider_id][el.id]) {
						delete controls[el.provider_id][el.id];
					} else {
						controls[el.provider_id][el.id] = el;
					}
				}
			} else if (type === 'timezone') {
				controls = state.state;

				el.states.forEach((state) => {
					if (timezonesValue[el.id]) {
						delete controls[state.id];
					} else {
						controls[state.id] = state;
					}
				});
			} else if (
				controls[el.id] ||
				controls[el.latest_version] ||
				controls[el.old_version] ||
				controls[el.provider_id]
			) {
				delete controls[el.id];
				delete controls[el.latest_version];
				delete controls[el.old_version];
				if (el && el.provider_id) {
					if (Array.isArray(el.provider_id)) {
						delete controls[el.provider_id.join(',')];
					} else {
						delete controls[el.provider_id];
					}
				}
				if (type === 'provider') {
					delete state.pinCodesByProvider[el.id];
				}
			} else if (type === 'FirmwareData_LV' && el.latest_version) {
				controls[el.latest_version] = el;
			} else if (type === 'FirmwareData_OV' && el.old_version) {
				controls[el.old_version] = el;
			} else if (type === 'dataValues' && el.provider_id) {
				controls[el.provider_id] = el;
			} else {
				controls[el.id] = el;

				if (type === 'provider') {
					state.pinCodesByProvider[el.id] = arrayToObject(
						el.provider_codes,
						'id',
					);
				}
			}

			return { controlsGroups: state, allDevices: false, errorsMsg: null };
		}, this.getMatch);
	};

	checkAll = () => {
		const {
			pinCodesData,
			providersData,
			errorsData,
			modelsData,
			providersNotifiabledata,
			firmwaresNotifiabledata,
			firmwaresData,
			statesData,
			citiesData,
		} = this.props;
		const allData = [
			{
				type: 'pinCodes',
				data: pinCodesData,
			},
			{
				type: 'provider',
				data: providersData,
			},
			{
				type: 'errors',
				data: errorsData,
			},
			{
				type: 'models',
				data: modelsData,
			},
			{
				type: 'dataValues',
				data: providersNotifiabledata,
			},
			{
				type: 'FirmwareData_LV',
				data: firmwaresNotifiabledata,
			},
			{
				type: 'FirmwareData_OV',
				data: firmwaresNotifiabledata,
			},
			{
				type: 'firmware',
				data: firmwaresData,
			},
			{
				type: 'state',
				data: statesData,
			},
			{
				type: 'cities',
				data: citiesData,
			},
		];

		clearTimeout(this.timer);

		this.setState((prevState) => {
			const state = { ...prevState.controlsGroups };
			let allDevices;
			allData &&
				allData.forEach((group) => {
					const controls = state[group.type];
					group.data &&
						group.data.forEach((item) => {
							if (prevState.allDevices) {
								if (item && item.id) {
									delete controls[item.id];

									if (group.type === 'provider') {
										delete state.pinCodesByProvider[item.id];
									}
								}
								if (item && item.provider_id) {
									if (Array.isArray(item.provider_id)) {
										delete controls[item.provider_id.join(',')];
									} else {
										delete controls[item.provider_id];
									}
								}
								if (
									controls &&
									item &&
									(item.latest_version || item.old_version)
								) {
									if (
										Array.isArray(item.latest_version) ||
										Array.isArray(item.old_version)
									) {
										var latest_version_ids = item.latest_version.map(
											(el) => el.concentrator_firmware_id,
										);
										var old_version_ids = item.old_version.map(
											(el) => el.concentrator_firmware_id,
										);
										delete controls[old_version_ids.join(',')];
										delete controls[latest_version_ids.join(',')];
									}
								}
								allDevices = false;
							} else {
								if (item && item.id) {
									controls[item.id] = item;

									if (group.type === 'provider') {
										state.pinCodesByProvider[item.id] = arrayToObject(
											item.provider_codes,
											'id',
										);
									}
								}
								if (item && item.provider_id) {
									if (Array.isArray(item.provider_id)) {
										controls[item.provider_id.join(',')] = item;
									} else {
										controls[item.provider_id] = item;
									}
								}
								if (
									group.type === 'FirmwareData_LV' &&
									item.latest_version &&
									Array.isArray(item.latest_version)
								) {
									var latest_version_firmwareids = item.latest_version.map(
										(el) => el.concentrator_firmware_id,
									);
									controls[latest_version_firmwareids.join(',')] = item;
								}
								if (
									group.type === 'FirmwareData_OV' &&
									item.old_version &&
									Array.isArray(item.old_version)
								) {
									var old_version_firmwareids = item.old_version.map(
										(el) => el.concentrator_firmware_id,
									);
									controls[old_version_firmwareids.join(',')] = item;
								}
								allDevices = true;
							}
						});
				});

			return { controlsGroups: state, allDevices: allDevices, errorsMsg: null };
		}, this.getMatch);
	};

	setScheduleDate = (date, timezones, type) => {
		this.setState((prevState) => {
			const controls = { ...prevState.controls };

			timezones.forEach((timezone) => {
				controls.timezonesValues.data[timezone]
					? (controls.timezonesValues.data[timezone][type] = date)
					: (controls.timezonesValues.data[timezone] = { [type]: date });
			});

			return { controls };
		});
	};

	resetScheduleDate = () => {
		this.setState((prevState) => {
			const controls = { ...prevState.controls };

			controls.timezonesValues.data = {};

			return { controls };
		});
	};

	getMatch = () => {
		this.timer = setTimeout(() => {
			const {
				controls: { type },
				controlsGroups,
				allDevices,
			} = this.state;

			const checked = allDevices
				? '&'
				: createFilterString(controlsGroups, true);
			// Build postData in the required format
			const push_type_id = parseInt(Object.keys(type.checked)[0], 10);
			let postData = { push_type_id };

			if (!allDevices && checked) {
				// checked is an object from createFilterString(controlsGroups, true)
				const searchFieldsStr = checked.searchFields
					? Object.entries(checked.searchFields)
							.map(([k, v]) => `${k}:${v}`)
							.join(';')
					: null;
				const searchStr = checked.search
					? Object.entries(checked.search)
							.map(([k, v]) => {
								if (Array.isArray(v)) {
									return `${k}:${v.flat().join(',')}`;
								}
								return `${k}:${v}`;
							})
							.join(';')
					: null;
				const concentratorErrorRecallLastFilter =
					checked.concentratorErrorRecallLastFilter &&
					checked.concentratorErrorRecallLastFilter.length
						? `code:${checked.concentratorErrorRecallLastFilter[0].code.join(
								',',
						  )}`
						: null;
				const codeFilter =
					checked.codeFilter && checked.codeFilter.length
						? `error_id:${checked.codeFilter[0].error_id.join(',')}`
						: null;

				postData = {
					push_type_id,
					searchFields: searchFieldsStr,
					search: searchStr,
					concentratorErrorRecallLastFilter,
					codeFilter,
				};
			}

			if (checked) {
				axios
					.post(api.concentrator_profiles.notifiable, postData)
					.then((response) => {
						const { rows } = response.data;
						this.setState({ matches: rows });
					})
					.catch((err) => {
						console.error(err);
					});
			} else {
				this.setState({ matches: null });
			}
		}, 300);
	};

	checkNotifiable = (args) => {
		const {
			controls: { type },
		} = this.state;
		const { serial } = args;

		const params = {
			push_type_id: Object.keys(type.checked)[0],
			search: {
				serial_number: serial,
			},
			searchFields: {
				serial_number: 'ilike',
			},
			limit: 5,
		};

		return axios
			.get(api.concentrator_profiles.notifiable, { params })
			.then((response) => response.data.rows);
	};

	sendHandler = () => {
		const {
			controls: { title, type, description, timezonesValues, url_to_open },
			controlsGroups,
			allDevices,
		} = this.state;
		const {
			addPushNotification,
			update,
			user,
			timezonesData,
			isMultiStepForm,
			selectedSerialNumbers,
			selectedConcentratorProfileIds,
			t,
		} = this.props;
		const body = description.value;
		let cpFilter = null;
		if (isMultiStepForm === false) {
			// "concentrator_profiles_filter": "search=serial_number:24502670,24453591;&searchFields=serial_number:in",
			const serialNumberValues = selectedSerialNumbers
				.map((serial) => `${serial}`)
				.join(',');
			const cpNumberValues = selectedConcentratorProfileIds
				.map((serial) => `${serial}`)
				.join(',');
			// cpFilter = `search=serial_number:${serialNumberValues}&searchFields=serial_number:in`;
			cpFilter = `search=serial_number:${serialNumberValues};concentrator_profile_id:${cpNumberValues}&searchFields=serial_number:in;concentrator_profile_id:in`;
		} else {
			cpFilter = allDevices ? '&' : createFilterString(controlsGroups);
			console.log('sendHandler:::::');
		}
		const postData = {
			body,
			push_type_id: Object.keys(type.checked)[0],
			concentrator_profiles_filter: cpFilter,
			title: title.value,
			url_to_open: url_to_open.value,
			user_id: user.id,
			created_at: moment().utc().format('YYYY-MM-DDTHHmmssZ'),
		};

		const timezones = Object.keys(timezonesValues.data);
		if (timezones.length) {
			postData.schedule = timezones.map((timezone) => {
				const result = moment
					.utc(timezonesValues.data[timezone].date)
					.add(timezonesValues.data[timezone].min || 0, 'minutes')
					.add(-timezonesData[timezone].utc_offset_hours, 'hours')
					.format('YYYY-MM-DDTHH:mm:ss\\Z');

				return {
					timezone_id: timezonesData[timezone].id,
					scheduled_at: result,
				};
			});
		}

		const args = {
			data: postData,
			success: () => {
				ReactGA.event({
					category: 'Notifications',
					action: 'Create',
					label: t('amount_of_created_notifications'),
				});

				ReactGA.event({
					category: 'Notifications',
					action: 'Create',
					label: `Create ${
						Object.values(type.checked)[0].code
					} Notifications Success`,
				});

				this.close();
				update();
			},
			error: (data) => {
				this.setState({ isSending: false, errorsMsg: data });
			},
		};

		this.setState({ isSending: true });
		addPushNotification(args);
	};

	onAutosuggestTyping = (type) => (e) => {
		e.persist();

		const { value } = e.target;

		if (value) {
			if (
				(type === 'concentrators' ? /^\d+$/.test(value) : true) &&
				value.length <= 8
			) {
				this.setState((prevState) => {
					const controls = { ...prevState.controls };
					const state = { controls };

					if (controls[type].value !== value) {
						state[`${type}Suggestions`] = [];
					}

					controls[type].value = value;

					return state;
				});
			}
		} else {
			this.setState((prevState) => {
				const controls = { ...prevState.controls };

				controls[type].value = value;

				return { controls };
			});
		}
	};

	onSuggestions =
		(type, param) =>
		({ value, reason }) => {
			const minChar = type === 'cities' ? 1 : 4;

			if (reason === 'suggestion-selected' || value.length < minChar) {
				return;
			}

			if (this.cache[type][value]) {
				this.setState({
					[`${type}Suggestions`]: this.cache[type][value],
				});
			} else {
				clearTimeout(this.timer);

				this.timer = setTimeout(() => {
					const params = {
						push_type_id: 1,
						search: {
							[param]: value,
						},
						searchFields: {
							[param]: 'ilike',
						},
						limit: 5,
					};

					let uri = api.cities.notifiable;

					if (type === 'concentrators') {
						uri = api.concentrator_profiles.notifications;
						params.searchJoin = 'and';
						params.push_type_id = null;
					}

					axios
						.get(uri, { params })
						.then((response) => {
							if (this.state.serial === '') {
								return;
							}

							this.cache[type][value] = response.data.data;

							this.setState({ [`${type}Suggestions`]: response.data.data });
						})
						.catch((err) => {
							console.error(err);
						});
				}, 300);
			}
		};

	onAutosuggestClear = (type, callback) => () =>
		this.setState({ [`${type}Suggestions`]: [] }, callback);

	onItemClicked =
		(type) =>
		async (e, { suggestion }) => {
			const args = { serial: suggestion.serial_number };

			if (type === 'concentrators' && !(await this.checkNotifiable(args))) {
				const callback = () =>
					setTimeout(() => this.setState({ isNotNotifiable: false }), 4000);

				this.setState(
					{
						isNotNotifiable: true,
					},
					this.onAutosuggestClear(type, callback),
				);
			} else {
				this.setState((prevState) => {
					const controlsGroups = { ...prevState.controlsGroups };
					const controls = { ...prevState.controls };

					controlsGroups[type][suggestion.id] = suggestion;
					controls[type].value = '';

					return { controls, controlsGroups, [`${type}Suggestions`]: [] };
				}, this.getMatch);
			}
		};

	onItemRemove = (type, id) => {
		this.setState((prevState) => {
			const controlsGroups = { ...prevState.controlsGroups };

			delete controlsGroups[type][id];

			return { controlsGroups };
		}, this.getMatch);
	};

	onAutosuggestSubmit = (type) => async () => {
		const suggestions = this.state[`${type}Suggestions`];

		if (suggestions.length === 1) {
			const args = { serial: suggestions[0].serial_number };

			if (type === 'concentrators' && !(await this.checkNotifiable(args))) {
				const callback = () =>
					setTimeout(() => this.setState({ isNotNotifiable: false }), 3000);

				this.setState((prevState) => {
					const controls = { ...prevState.controls };

					controls[type].value = '';

					return {
						isNotNotifiable: true,
						controls,
						[`${type}Suggestions`]: [],
					};
				}, callback);
			} else {
				this.setState(
					(prevState) => {
						const controls = { ...prevState.controls };
						const controlsGroups = { ...prevState.controlsGroups };

						controlsGroups[type][suggestions[0].id] = suggestions[0];
						controls[type].value = '';

						return { controls, controlsGroups, [`${type}Suggestions`]: [] };
					},
					() => clearTimeout(this.timer),
				);
			}
		}
	};

	filtersList = (allChecked) => {
		const {
			controlsGroups: {
				pinCodes,
				provider,
				errors,
				models,
				dataValues,
				FirmwareData_LV,
				FirmwareData_OV,
				firmware,
				state,
				cities,
				concentrators,
			},
		} = this.state;
		const { t } = this.props;

		if (allChecked) {
			return (
				<ul className={s.checkedList}>
					<li>
						{t('all_devices')}
						<i className={s.remove} onClick={this.checkAll} />
					</li>
				</ul>
			);
		}

		return (
			<ul className={s.checkedList}>
				{Object.values(provider).map((el, index) => (
					<li key={index}>
						{el.name}
						<i
							className={s.remove}
							onClick={(e) => this.checkboxChangedHandler(e, el, 'provider')}
						/>
					</li>
				))}
				{Object.values(pinCodes).map((el, index) => (
					<li key={index}>
						{el.code}
						<i
							className={s.remove}
							onClick={(e) => this.checkboxChangedHandler(e, el, 'pinCodes')}
						/>
					</li>
				))}
				{Object.values(errors).map((el, index) => (
					<li key={index}>
						{el.description}
						<i
							className={s.remove}
							onClick={(e) => this.checkboxChangedHandler(e, el, 'errors')}
						/>
					</li>
				))}
				{Object.values(models).map((el, index) => (
					<li key={index}>
						{el.description}
						<i
							className={s.remove}
							onClick={(e) => this.checkboxChangedHandler(e, el, 'models')}
						/>
					</li>
				))}
				{Object.values(dataValues).map((el, index) => (
					<li key={index}>
						{el.provider_id}
						<i
							className={s.remove}
							onClick={(e) => this.checkboxChangedHandler(e, el, 'dataValues')}
						/>
					</li>
				))}
				{Object.values(FirmwareData_LV).map((el, index) => (
					<li key={index}>
						{el.latest_version}
						<i
							className={s.remove}
							onClick={(e) =>
								this.checkboxChangedHandler(e, el, 'FirmwareData_LV')
							}
						/>
					</li>
				))}
				{Object.values(FirmwareData_OV).map((el, index) => (
					<li key={index}>
						{el.old_version}
						<i
							className={s.remove}
							onClick={(e) =>
								this.checkboxChangedHandler(e, el, 'FirmwareData_OV')
							}
						/>
					</li>
				))}
				{Object.values(firmware).map((el, index) => (
					<li key={index}>
						{el.version}
						<i
							className={s.remove}
							onClick={(e) => this.checkboxChangedHandler(e, el, 'firmware')}
						/>
					</li>
				))}
				{Object.values(state).map((el, index) => (
					<li key={index}>
						{el.state_name}
						<i
							className={s.remove}
							onClick={(e) => this.checkboxChangedHandler(e, el, 'state')}
						/>
					</li>
				))}
				{Object.values(cities).map((el, index) => (
					<li key={index}>
						{el.city}
						<i
							className={s.remove}
							onClick={() => this.onItemClicked(el, true, 'cities')}
						/>
					</li>
				))}
				{Object.values(concentrators).map((el, index) => (
					<li key={index}>
						{el.serial_number}
						<i
							className={s.remove}
							onClick={() => this.onItemClicked(el, true, 'concentrators')}
						/>
					</li>
				))}
			</ul>
		);
	};

	firstStep = () => {
		const { controls, formIsValid } = this.state;
		const { typesData, isMultiStepForm } = this.props;

		return (
			<FirstStep
				typesData={typesData}
				controls={controls}
				isValid={formIsValid}
				inputChangedHandler={this.inputChangedHandler}
				inputFocusOutHandler={this.inputFocusOutHandler}
				nextHandler={() => this.setState({ step: 2 })}
				close={this.props.closeModal}
				isMultiStepForm={isMultiStepForm}
				sendHandler={this.sendHandler}
				selectedRowsInfo={this.props.selectedSerialNumbers}
			/>
		);
	};

	secondStep = () => {
		const {
			pinCodesData,
			providersData,
			errorsData,
			modelsData,
			providersNotifiabledata,
			firmwaresNotifiabledata,
			firmwaresData,
			statesData,
			timezonesData,
			currentUserData,
		} = this.props;
		const {
			controls: { cities, concentrators },
			controlsGroups,
			citiesSuggestions,
			concentratorsSuggestions,
			errorsMsg,
			isSending,
			allDevices,
			matches,
			isNotNotifiable,
		} = this.state;

		return (
			<SecondStep
				citiesControl={cities}
				concentratorsControl={concentrators}
				controlsGroups={controlsGroups}
				citiesSuggestions={citiesSuggestions}
				concentratorsSuggestions={concentratorsSuggestions}
				errorsMsg={errorsMsg}
				isAllDevices={allDevices}
				isSending={isSending}
				isNotNotifiable={isNotNotifiable}
				matches={matches}
				pinCodesData={pinCodesData}
				providersData={providersData}
				errorsData={errorsData}
				currentUserData={currentUserData}
				modelsData={modelsData}
				providersNotifiabledata={providersNotifiabledata}
				firmwaresNotifiabledata={firmwaresNotifiabledata}
				firmwaresData={firmwaresData}
				statesData={statesData}
				timezonesData={timezonesData}
				checkboxChangedHandler={this.checkboxChangedHandler}
				onAutosuggestTyping={this.onAutosuggestTyping}
				onSuggestions={this.onSuggestions}
				onAutosuggestSubmit={this.onAutosuggestSubmit}
				onItemClicked={this.onItemClicked}
				onItemRemove={this.onItemRemove}
				sendHandler={this.sendHandler}
				onAutosuggestClear={this.onAutosuggestClear}
				checkAllHandler={this.checkAll}
				nextHandler={(selectedTimezones) => {
					this.selectedTimezones = selectedTimezones;
				}}
			/>
		);
	};

	modalBody = () => {
		const { step } = this.state;
		const { t } = this.props;
		// let title;
		let currentStep;
		let backBtn;
		switch (step) {
			case 1:
				currentStep = this.firstStep();
				// title = i18next.t("create_notification");
				break;
			case 2:
				currentStep = this.secondStep();
				// title = t("target_users");
				backBtn = (
					<Button
						className={s.titleBackBtn}
						btnType='back'
						clicked={() => this.setState({ step: 1 })}
					>
						<Back width='36' fill='#6D6D6D' height='36' />
					</Button>
				);
				break;
			default:
				break;
		}

		return (
			<Fragment>
				<div className={s.containerAlignment}>
					<div className={s.titleAlign}>
						<div className={s.iconTitle}>
							{backBtn}
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='36'
								height='36'
								viewBox='0 0 36 36'
								fill='none'
							>
								<path
									d='M17.9974 32.5384C17.251 32.5384 16.613 32.2729 16.0832 31.7419C15.5534 31.2109 15.2885 30.5725 15.2885 29.8269H20.7115C20.7115 30.5749 20.4457 31.2139 19.9142 31.7437C19.3827 32.2735 18.7438 32.5384 17.9974 32.5384ZM7.60095 28.3269C7.35985 28.3269 7.15775 28.2446 6.99465 28.0801C6.83155 27.9156 6.75 27.7118 6.75 27.4686C6.75 27.2254 6.83155 27.024 6.99465 26.8644C7.15775 26.7048 7.35985 26.625 7.60095 26.625H9.46155V14.7779C9.46155 12.7468 10.0779 10.9357 11.3106 9.34451C12.5433 7.75329 14.1481 6.76681 16.125 6.38509V5.625C16.125 5.10418 16.3071 4.66148 16.6714 4.2969C17.0356 3.9323 17.4779 3.75 17.9983 3.75C18.5186 3.75 18.9615 3.9323 19.3269 4.2969C19.6922 4.66148 19.8749 5.10418 19.8749 5.625V6.38531C20.4019 6.49574 20.9072 6.64905 21.3909 6.84525C21.8746 7.04143 22.3298 7.29044 22.7566 7.59229C22.5387 7.81491 22.3501 8.04796 22.1908 8.29144C22.0315 8.53494 21.8711 8.7836 21.7095 9.03743C21.173 8.67975 20.5915 8.40764 19.965 8.22109C19.3384 8.03456 18.6834 7.9413 18 7.9413C16.1057 7.9413 14.4928 8.60716 13.161 9.93889C11.8293 11.2706 11.1634 12.8836 11.1634 14.7779V26.625H24.8365V21.0923C25.1096 21.2654 25.3825 21.4208 25.6553 21.5586C25.928 21.6964 26.2224 21.8159 26.5384 21.9173V26.625H28.399C28.6401 26.625 28.8422 26.7073 29.0053 26.8718C29.1684 27.0363 29.2499 27.2401 29.2499 27.4833C29.2499 27.7264 29.1684 27.9278 29.0053 28.0875C28.8422 28.2471 28.6401 28.3269 28.399 28.3269H7.60095ZM28.6009 14.3509H24.6778C24.4367 14.3509 24.2346 14.2687 24.0715 14.1042C23.9084 13.9396 23.8269 13.7358 23.8269 13.4926C23.8269 13.2494 23.9084 13.0481 24.0715 12.8885C24.2346 12.7288 24.4367 12.649 24.6778 12.649H28.6009V8.72595C28.6009 8.48485 28.6832 8.28275 28.8477 8.11965C29.0122 7.95655 29.216 7.875 29.4592 7.875C29.7024 7.875 29.9037 7.95655 30.0634 8.11965C30.223 8.28275 30.3028 8.48485 30.3028 8.72595V12.649H34.2259C34.467 12.649 34.6691 12.7313 34.8322 12.8958C34.9953 13.0603 35.0768 13.2641 35.0768 13.5073C35.0768 13.7505 34.9953 13.9519 34.8322 14.1115C34.6691 14.2711 34.467 14.3509 34.2259 14.3509H30.3028V18.274C30.3028 18.5151 30.2205 18.7172 30.056 18.8803C29.8915 19.0434 29.6877 19.1249 29.4445 19.1249C29.2013 19.1249 28.9999 19.0434 28.8403 18.8803C28.6807 18.7172 28.6009 18.5151 28.6009 18.274V14.3509Z'
									fill='#26251F'
								/>
							</svg>
							<span className={s.titleTypography}>
								{t('createNotification')}
							</span>
						</div>
						<Close
							className={s.closeBtn}
							width={36}
							height={36}
							fill='#6D6D6D'
							onClick={this.close}
						/>
					</div>
					{this.props.isMultiStepForm !== false && (
						<div className={s.stepAlign}>
							{i18next.t('step')} {step} {i18next.t('of')} 2
						</div>
					)}
					{currentStep}
				</div>
			</Fragment>
		);
	};

	close = () => {
		this.props.closeModal();
	};

	render() {
		logger('[CreateModal] Render');
		const { step } = this.state;
		const classes = [s.newModal];

		if (step === 2) {
			classes.push(s.type);
		}

		return (
			<Modal
				className={classes.join(' ')}
				loading={this.state.loading}
				show={this.props.isOpen}
				newDesign={true}
				modalClosed={this.close}
				restrictClosing={this.props.restrictClosing}
			>
				{this.modalBody()}
			</Modal>
		);
	}
}

export default withTranslation()(CreateModal);
